import script from "./Input.vue?vue&type=script&setup=true&lang=ts"
export * from "./Input.vue?vue&type=script&setup=true&lang=ts"

import "./Input.vue?vue&type=style&index=0&id=1e889642&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e889642"]])

export default __exports__